'use strict';
const _ = require('lodash');

module.exports = (input) => {
  if (_.isNil(input) || _.isEmpty(input)) {
    return input;
  }

  const pattern = /th\.|[a-z]/gi;
  const matches = input.match(pattern);

  if (_.isNil(matches)) {
    return '';
  }

  return matches
    .map((match) => {
      if (/\.$/i.test(match)) {
        return _.upperFirst(match.substr(0, match.length - 1));
      } else {
        return _.upperFirst(match);
      }
    })
    .join('.') + '.';
};
